// A blank line in the editor serializes either as a plain newline or, when another blank
// line follows it, as a markdown hard break (`\` + newline). `String#trim` only clears the
// first kind, so leading blank lines survive it.
const BLANK_EDGES = /^(?:\s|\\(?=\r?\n))+|(?:\s|\\(?=\r?\n))+$/g;

export const trimEditorContent = (content = '') =>
  content.replace(BLANK_EDGES, '');
